import { apiAxiosQuatro } from "./appAxios";
import { tokenFunc } from "./tokenService";

const call = async (url, params) => {
  try {
    const { data } = await apiAxiosQuatro.get(url, {
      params,
      headers: { Authorization: await tokenFunc() },
    });
    return { status: true, data: data?.data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.message || error?.message,
    };
  }
};

export const getPanicAlertListService = (params) => call(`/PanicAlert/GetList`, params);
export const getPanicAlertSummaryService = () => call(`/PanicAlert/GetSummary`);
export const getPanicAlertsNewerService = (afterId, limit = 50) =>
  call(`/PanicAlert/GetNewer`, { afterId, limit });
export const getPanicAlertService = (id) => call(`/PanicAlert/Get/${id}`);

// Sunucu tarihleri UTC döner, bazen sonunda Z olmaz
export const parseUtcDate = (value) => {
  if (!value) return null;
  const text = String(value);
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(text);
  const date = new Date(hasZone ? text : `${text}Z`);
  return isNaN(date.getTime()) ? null : date;
};

export const formatIstanbul = (value) => {
  const date = parseUtcDate(value);
  if (!date) return "-";
  return date.toLocaleString("tr-TR", { timeZone: "Europe/Istanbul" });
};

// REST'te vehicleID, SignalR'da vehicleId gelir; tek biçime çevrilir
export const normalizePanicAlert = (a) => ({
  id: a.id,
  vehicleID: a.vehicleID ?? a.vehicleId,
  plate: a.plate,
  imei: a.imei,
  lat: a.lat,
  long: a.long,
  occurredAt: a.occurredAt,
  receivedAt: a.receivedAt,
  notificationSent: a.notificationSent,
});

export const PANIC_HUB_URL = `${apiAxiosQuatro.defaults.baseURL.replace(/\/api\/?$/, "")}/hubs/notifications`;
